






import { Vue, Component } from "vue-property-decorator";

@Component({})
export default class PlusIcon extends Vue {}
